const region = "us-east-1";
const origin = window.location.origin;

const prod = {
  appSettingsData: {
    // generate a file format limit of video file
    federatedEngageAIProvider: "wl-pd-logocloud-production-idp",
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: region,
      userPoolId: "us-east-1_1akOhfVL6",
      userPoolWebClientId: "61ck6bl3d3deui9k8ohdmcskcq",
    },
    oauth: {
      domain: "auth.production.wl-logocloud.com",
      scope: [],
      redirectSignIn: `${origin}/image-verification`,
      redirectSignOut: `${origin}/image-verification`,
      responseType: "code",
      clientId: "61ck6bl3d3deui9k8ohdmcskcq",
    },
    API: {
      endpoints: [
        {
          name: "logoCloud",
          // endpoint: "https://api.dev.wl-dms.com",
          endpoint: "https://api.production.wl-logocloud.com",
          region: region,
        },
        {
          name: "logoCloudLivePlatform",
          endpoint: "https://api.production.wl-logocloud.com/live",
          region: region,
        },
        {
          name: "logoCloudImageVerification",
          endpoint: "https://api.production.wl-logocloud.com/image-verifications",
          region: region,
        },
        {
          name: "logoCloudImageCollection",
          endpoint: "https://api.production.wl-logocloud.com/image-collections",
          region: region,
        },
        {
          name: "LogoCloudTenants",
          endpoint: "https://api.production.wl-logocloud.com/settings/tenants",
          region: region,
        },
      ],
    },
  },
};
// type demoType = typeof demo

export type ProdType = typeof prod;
export default prod;
